import { LocaleOverrideProvider } from "@/lib/locale/locale-provider";
import MaritimeForecastBase from "@/features/shared/widgets/maritime-forecast/MaritimeForecast";
import type { MaritimeForecastWidgetConfiguration } from "@/lib/api";

type MaritimeForecastWidgetProps = {
  id: string;
  data: unknown;
  configuration: MaritimeForecastWidgetConfiguration;
};

const MaritimeForecast = (props: MaritimeForecastWidgetProps) => (
  <LocaleOverrideProvider locale="nl">
    <MaritimeForecastBase {...props} />
  </LocaleOverrideProvider>
);

export default MaritimeForecast;
